/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
/* eslint-disable no-console */
import React, { useState, MouseEvent } from "react";

import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

import ErrorIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { setTokenErrorOpen, setTokenErrorOpenSetter } from "../../logic/hook/useDialogStateHelper";
import { router } from "../../logic/hook/useRouterNavigation";
import { logout } from "../../logic/authorization/Authorization";
import { StyledDialog } from "./Dialog";
import { getLmWindow, setLmWindow } from "../../logic/hook/useWindowStateHelper";

export const TokenErrorDialog = () => {
    const [open, setOpen] = useState(false);
    setTokenErrorOpenSetter(setOpen);
    setTokenErrorOpen(open);

    const onClose = (event: MouseEvent<HTMLInputElement>, reason: "backdropClick") => {
        // バックドロップクリック時に閉じるのを無効化
        if (reason === "backdropClick") {
            return;
        }

        // LM画面のタブが閉じていない場合はタブを閉じる。
        const sub = getLmWindow();
        if (sub && !sub.closed) {
            sub.close();
        }
        setLmWindow(null);
        // ログアウトして、ログイン画面を表示
        logout();
        router("/");
        // エラーダイアログを閉じる。
        setOpen(false);
    };

    const onClickOK = () => {
        // LM画面のタブが閉じていない場合はタブを閉じる。
        const sub = getLmWindow();
        if (sub && !sub.closed) {
            sub.close();
        }
        setLmWindow(null);
        // ログアウトして、ログイン画面を表示
        logout();
        router("/");
        // エラーダイアログを閉じる。
        setOpen(false);
    };

    return (
        <>
            <StyledDialog open={open} onClose={onClose} fullWidth>
                <DialogTitle component="div">
                    <Grid container direction="row" justifyContent="flex-start" alignItems="center" sx={{ width: "100%" }}>
                        <ErrorIcon />
                        エラー
                    </Grid>
                </DialogTitle>
                <DialogContent dividers sx={{ maxHeight: "70vh" }}>
                    <DialogContentText
                        dangerouslySetInnerHTML={{
                            __html: "セッションが不正です。<br/>再度、ログイン画面から正しくログインして下さい。",
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClickOK} size="small">
                        OK
                    </Button>
                </DialogActions>
            </StyledDialog>
        </>
    );
};
